import { render } from "./wfEmailTemplates.vue?vue&type=template&id=30826426"
import script from "./wfEmailTemplates.vue?vue&type=script&lang=js"
export * from "./wfEmailTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__